<template>
  <Suspense>
    <template #default>
      <component v-if="renderComponent" v-bind:is="currentTabComponent" :unidad="$route.params.unidad" :diapositiva="$route.params.diapositiva"></component>
    </template>
    <template #fallback>
      <img src="@/assets/images/Logo_Funifelt_Color.png">
    </template>
  </Suspense>

  <!-- Botones para cambiar de diapositiva -->
  <div class="controles">
    <button @click="moverDiapositiva('<')" class="moveButton">
      <i class="fa-solid fa-angle-left" style="color: #ffffff;"></i>
    </button>
    <button @click="volverAUnidades()" class="moveButton">
      <i class="fa-solid fa-house" style="color: #ffffff;"></i>
    </button>
    <button @click="moverDiapositiva('>')" class="moveButton">
      <i class="fa-solid fa-angle-right" style="color: #ffffff;"></i>
    </button>
  </div>

  <!-- Reproductor de audio invisible, solamente reproduce el sonido de introduccion a la unidad -->
  <audio id="audioElement" style="display: none;">
    <source src="" type="audio/mpeg">
    Tu navegador no soporta el elemento de audio.
  </audio>

</template>

<script>
// Firebase database imports
import { db } from '@/main.js'
import { collection, getDocs, query, orderBy } from 'firebase/firestore'


// Layouts imports
import { defineAsyncComponent } from 'vue';


export default {
  name: 'DiapositivaView',
  props: {
    unidad: { type: String, required: true },
    diapositiva: { type: String, required: true }
  },
  components: {
    // layouts
    main1: defineAsyncComponent(() => import("@/components/layouts/main.vue")),
    explication_one: defineAsyncComponent(() => import("@/components/layouts/explication_one.vue")),
    guide_introduction: defineAsyncComponent(() => import("@/components/layouts/guide_introduction.vue")),
    audio_plus_video: defineAsyncComponent(() => import("@/components/layouts/audio_plus_video.vue")),
    image_multioption: defineAsyncComponent(() => import("@/components/layouts/image_multioption.vue")),
    audio_finished: defineAsyncComponent(() => import("@/components/layouts/audio_finished.vue")),
    center_video: defineAsyncComponent(() => import("@/components/layouts/center_video.vue")),
    activity_one: defineAsyncComponent(() => import("@/components/layouts/activity_one.vue")),
    two_videos: defineAsyncComponent(() => import("@/components/layouts/two_videos.vue")),
    options_image: defineAsyncComponent(() => import("@/components/layouts/options_image.vue")),
    image_plus_video: defineAsyncComponent(() => import("@/components/layouts/image_plus_video.vue")),
    multiple_audios: defineAsyncComponent(() => import("@/components/layouts/multiple_audios.vue")),
    drag_and_drop1: defineAsyncComponent(() => import("@/components/layouts/drag_and_drop1.vue")),
    activity_with_audios: defineAsyncComponent(() => import("@/components/layouts/activity_with_audios.vue")),
    diptongo_words_with_images: defineAsyncComponent(() => import("@/components/layouts/diptongo_words_with_images.vue")),
    diptongo_classification: defineAsyncComponent(() => import("@/components/layouts/diptongo_classification.vue")),
    audio_plus_video2: defineAsyncComponent(() => import("@/components/layouts/audio_plus_video2.vue")),
    drag_drop_diptongo2: defineAsyncComponent(() => import("@/components/layouts/drag_drop_diptongo2.vue")),
    autoevaluation: defineAsyncComponent(() => import("@/components/layouts/autoevaluation.vue")),
    feedback_unity: defineAsyncComponent(() => import("@/components/layouts/feedback_unity.vue")),
    image_with_audio: defineAsyncComponent(() => import("@/components/layouts/image_with_audio.vue")),
    information_list: defineAsyncComponent(() => import("@/components/layouts/information_list.vue")),
    activity_with_board: defineAsyncComponent(() => import("@/components/layouts/activity_with_board.vue")),
    multiple_videos: defineAsyncComponent(() => import("@/components/layouts/multiple_videos.vue")),
    center_image: defineAsyncComponent(() => import("@/components/layouts/center_image.vue")),
  },
  data () {
    return {
      renderComponent: false,
      listaDeDiapositivas: [],
      unidadActual: this.$route.params.unidad,
      currentTabComponent: null,
    }
  },
  async mounted () {
    // Obtener la inicial actual
    const unidadActual = this.$route.params.unidad

    // Obtener todas la diapositivas de la unidad actual
    let listaDeD = []
    const coleccionDeD = collection(db, unidadActual)
    const q = query(coleccionDeD, orderBy('id'))

    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      listaDeD.push(doc.data())
    })


    // Guardar la lista de jergas en el data
    this.listaDeDiapositivas = listaDeD

    // Obtener el layout de la diapositiva actual
    this.getActualLayout()
    await this.$nextTick()
    this.renderComponent = true

    // Reproducir sonido
    const audioElement = document.getElementById("audioElement")
    audioElement.src = listaDeD[0].data.audioSrc
    audioElement.play()
  },
  methods: {
    getActualLayout () {
      for (let i = 0; i < this.listaDeDiapositivas.length; i++) {
        if (this.listaDeDiapositivas[i].id === parseInt(this.$route.params.diapositiva)) {
          this.currentTabComponent = this.listaDeDiapositivas[i].architectureType
          break
        }
      }
    },
    async actualizarComponente () {
      this.renderComponent = false // Ocultar el componente
      this.getActualLayout() // Obtener el layout de la diapositiva nueva
      await this.$nextTick()
      this.renderComponent = true // Mostrar el componente con el nuevo layout 
    },
    async moverDiapositiva (direccion) {
      let listaDeDiapositivas = this.listaDeDiapositivas
      let unidadActual = this.unidadActual
      let anterior 
      let siguiente

      // Obtener la diapositiva actual
      for (let i = 0; i < listaDeDiapositivas.length; i++) {
        if (listaDeDiapositivas[i].id === parseInt(this.$route.params.diapositiva)) {
          anterior = listaDeDiapositivas[i - 1]
          siguiente = listaDeDiapositivas[i + 1]
          break
        } 
      }

      // Si no se encontró la anterior o la siguiente, se asigna la primera o la última
      if (anterior === undefined) {
        anterior = listaDeDiapositivas[listaDeDiapositivas.length - 1]
      } 
      if (siguiente === undefined) {
        siguiente = listaDeDiapositivas[0]
      } 

      // Determinar la direccion en la que se desea mover (anterior o siguiente)
      if (direccion === '<') {
        await this.$router.push({ name: 'unidad', params: { unidad: unidadActual, diapositiva: anterior.id } })
        //await this.$router.push({ name: 'unidad', params: { unidad: unidadActual, diapositiva: anterior.numero } })
      } else {
        await this.$router.push({ name: 'unidad', params: { unidad: unidadActual, diapositiva: siguiente.id } })
      }

      // Actualizar el componente
      this.actualizarComponente()
    },
    volverAUnidades () {
      this.$router.push({ name: 'unidades' })
    }
  }
}

</script>

<style scoped>
img {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.controles {
  position: relative;
  bottom: -150px;
  background-color: white;
  width: 100%;
}
.moveButton {
  width: 50px;
  height: 50px;
  background-color: #25274F;
  border-radius: 50%;
  border: 0px;
  display: inline-block;
  cursor: pointer;
  color: white;
  text-decoration: none;  
  font-size: 18pt;
  margin: 20px 10px;
}
.moveButton:hover {
  background-color: #3F51B5;
}

@media (max-width: 1000px) {
  img {
    width: auto;
    height: 10vh;
  }

  .moveButton:hover {
    background-color: #25274F;
  }
}
</style>
